import { groupValidators } from '@framework/ui/Organisms/FinalForm/validators/helpers';
import { validateMaxLength } from '@framework/ui/Organisms/FinalForm/validators/validateMaxLength';
import { validateMinLength } from '@framework/ui/Organisms/FinalForm/validators/validateMinLength';
import { validateRequiredField } from '@framework/ui/Organisms/FinalForm/validators/validateRequiredField';

export default (values): object | null => {
  return groupValidators(
    validateMinLength({
      fieldName: 'portfolioName',
      fieldCaption: 'Portfolio name',
      value: values.portfolioName,
      length: 3,
    }),
    validateMaxLength({
      fieldName: 'portfolioName',
      fieldCaption: 'Portfolio name',
      value: values.portfolioName,
      length: 50,
    }),
    validateRequiredField(
      {
        fieldName: 'portfolioName',
        fieldCaption: 'Portfolio name',
        value: values.portfolioName,
      },
    ),
  );
};
